module.exports = __webpack_public_path__ + "static/media/P2.116514e8.svg";